import { render, staticRenderFns } from "./WorkSheetsAndProjectsPanel.vue?vue&type=template&id=4d6d3196"
import script from "./WorkSheetsAndProjectsPanel.vue?vue&type=script&lang=js"
export * from "./WorkSheetsAndProjectsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkSheetsAndProjectsPanel.vue?vue&type=style&index=0&id=4d6d3196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports